import React from "react"
import Layout from "./src/gatsby-theme-wild-child/components/Layout"
import { Script } from "gatsby"

export const wrapPageElement = ({ element }) => {
  return (
    <Layout>
      <Script
        src={`https://www.googletagmanager.com/gtm.js?id=GTM-P9VZVCR`}
        forward={[`dataLayer.push`]}
      />
      <Script id="gtm-init">
        {`
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' })
        `}
      </Script>
      {element}
    </Layout>
  )
}
